module.exports = __webpack_public_path__ + "static/img/outOfService.b4afbb77.png";